import React, { useState } from 'react';
import { getThumbnailUrl } from '../services/youtubeService';

/**
 * Formats a date string to relative time (e.g. "3 months ago")
 */
function formatRelativeDate(dateString) {
    if (!dateString) return '';
    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now - date;
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

    if (diffDays < 1) return 'Today';
    if (diffDays === 1) return 'Yesterday';
    if (diffDays < 7) return `${diffDays} days ago`;
    if (diffDays < 30) return `${Math.floor(diffDays / 7)} weeks ago`;
    if (diffDays < 365) return `${Math.floor(diffDays / 30)} months ago`;
    return `${Math.floor(diffDays / 365)} years ago`;
}

export default function YouTubeVideoCard({ videoId, title, description, publishedAt, onClick }) {
    const [thumbQuality, setThumbQuality] = useState('maxresdefault');

    return (
        <div
            onClick={onClick}
            className={`
                bg-[#1a1a2e] border border-[#2a2a4a]
                rounded-lg overflow-hidden
                group cursor-pointer
                hover:border-[#6366f1]/50
                transition-all duration-300
            `}
        >
            {/* Thumbnail */}
            <div className="relative aspect-video overflow-hidden bg-black/20">
                <img
                    src={getThumbnailUrl(videoId, thumbQuality)}
                    alt={title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                    loading="lazy"
                    onError={() => {
                        if (thumbQuality === 'maxresdefault') setThumbQuality('hqdefault');
                    }}
                />
                {/* Play button overlay */}
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-black/30">
                    <div className="w-14 h-14 bg-red-600/90 rounded-full flex items-center justify-center shadow-lg">
                        <svg className="w-7 h-7 text-white ml-1" fill="currentColor" viewBox="0 0 24 24">
                            <path d="M8 5v14l11-7z" />
                        </svg>
                    </div>
                </div>
            </div>

            {/* Content */}
            <div className="p-3">
                <h3 className="font-semibold text-white text-sm line-clamp-2 leading-snug">
                    {title}
                </h3>
                {publishedAt && (
                    <p className="text-xs text-[#a0a0b0] mt-1.5">
                        {formatRelativeDate(publishedAt)}
                    </p>
                )}
            </div>
        </div>
    );
}
